import { CssBaseline } from '@mui/material'

import Providers from './components/Providers'
import Router from './routes'

export function App() {
	return (
		<div className='App'>
			<Providers>
				<CssBaseline />
				<Router />
			</Providers>
		</div>
	)
}
